import React from 'react';

import { Bookmark, BookmarkProps } from '@lumapps/bookmarks/components/Bookmarks/Bookmark/Bookmark';

/**
 * Customization bookmark that wraps the Bookmark component.
 * @param props - CustomizationBookmarkProps
 * @returns CustomizationBookmark
 */
export const CustomizationBookmark: React.FC<BookmarkProps> = (props) => {
    return <Bookmark {...props} />;
};

CustomizationBookmark.displayName = 'CustomizationBookmark';
